export type PassengerCategory = "adult" | "youth" | "child" | "infant";

/** Returns the passenger's category, or `undefined` when the transport cannot tell. */
export type GetPassengerCategory<Passenger> = (passenger: Passenger) => PassengerCategory | undefined;

/**
 * Lead guest of a passenger list: the first adult, then the first youth, then the first non-infant,
 * then the first passenger. A passenger with an unknown category counts as a non-infant.
 * Without `getCategory` the first passenger is used. Returns `undefined` only for an empty list.
 */
export const getLeadGuest = <Passenger>(
  passengers: Passenger[] | null | undefined,
  getCategory?: GetPassengerCategory<Passenger>
): Passenger | undefined => {
  const list = Array.isArray(passengers) ? passengers : [];
  const categoryOf = (passenger: Passenger) => getCategory?.(passenger);

  return (
    list.find(passenger => categoryOf(passenger) === "adult") ??
    list.find(passenger => categoryOf(passenger) === "youth") ??
    list.find(passenger => categoryOf(passenger) !== "infant") ??
    list[0]
  );
};
